const API_URL = import.meta.env.VITE_API_URL ?? "http://localhost:9000";

export function VedlikeholdPage() {
  return (
    <div className="flex flex-col h-[calc(100vh-0px)] sm:h-screen">
      <div className="flex items-center gap-3 px-6 py-4 border-b border-border">
        <div>
          <h1 className="text-lg font-semibold">Vedlikehold</h1>
          <p className="text-sm text-muted-foreground">Kødashboard og utviklerverktøy</p>
        </div>
      </div>
      <iframe
        src={`${API_URL}/admin/queues`}
        className="flex-1 w-full border-0"
        title="BullMQ Queue Dashboard"
      />
    </div>
  );
}
